import { render, staticRenderFns } from "./CurrentStatusForm.vue?vue&type=template&id=fa7296d6&"
import script from "./CurrentStatusForm.vue?vue&type=script&lang=js&"
export * from "./CurrentStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports